import styled from 'styled-components';
import { VStack } from '@bpba/ui-components';
import { CARROUSEL_RADIUS } from '../../constants/data';
import { SlideButton } from './SlideButton';
import {
  BackgroundProps,
  BorderProps,
  BorderRadiusProps,
  ColorProps,
  FlexboxProps,
  LayoutProps,
  MarginProps,
  PaddingProps,
  PositionProps,
  SpaceProps,
  TypographyProps,
  typography,
} from 'styled-system';
import { SLIDETITLE_DEFAULT_LABEL } from '../../constants/data';
import { SlideText } from './SlideText';
import { CuentaRegresiva } from './CuentaRegresiva';

type SlideTitleProps = {
  title?: string;
  callToAction?: string;
  display?: (string | null)[];
  description?: string;
  countdownDate?: string;
};

export function SlideTitle(props: SlideTitleProps) {
  const hasTitle: boolean = !!props?.title && props.title.trim().length > 0;
  const hasDescription: boolean = !!props?.description && props.description.trim().length > 0;
  const hasCallToAction: boolean = !!props?.callToAction && props.callToAction.trim().length > 0;
  const hasCountdown: boolean = !!props.countdownDate && props.countdownDate.trim().length > 0;

  const emptyCase = (): boolean => {
    return !hasTitle && !hasDescription && !hasCountdown && !hasCallToAction;
  };

  /**Caso con título o descripción o botón. */
  return (
    <StyledVStack
      display={props.display}
      width={['100%', 'auto']}
      right={[null, 60, null, 97]}
      padding={24}
      paddingBottom={[36, 24]}
      alignItems={hasCountdown ? 'center' : 'unset'}
      position={['relative', 'absolute']}
      zIndex={2}
      backgroundColor={hasTitle || hasDescription || hasCountdown || hasCallToAction ? 'primary.0-transp' : ''}
      color="white"
      overflow="hidden"
      borderRadius={CARROUSEL_RADIUS}
      fontWeight={400}
      tabIndex={emptyCase() ? 0 : -1}
      outline={emptyCase() ? 'none' : 'initial'}
      marginX={['16px', 'unset']}
      role="link"
      aria-label={emptyCase() ? SLIDETITLE_DEFAULT_LABEL : 'none'}
    >
      {hasTitle && <SlideText text={props.title} fontSize={['26px', '34px', null, '31px']} lineHeight={['33px', '41px', null, '38px']} />}
      {hasDescription && <SlideText text={props.description} fontSize={['14px', '18px', null, null]} lineHeight={['18px', '22px', null, null]} marginTop={hasTitle ? ['4px', '5px'] : []} />}

      {hasCountdown && <CuentaRegresiva fecha={props.countdownDate} includeMargin={hasTitle || hasDescription} />}
      {hasCallToAction && <SlideButton text={props?.callToAction} includeMargin={hasTitle || hasDescription || hasCountdown} />}
    </StyledVStack>
  );
}

type OutlineProps = {
  outline?: string;
};

type FlexBoxType = FlexboxProps | MarginProps | PaddingProps | SpaceProps | BorderRadiusProps | PositionProps | LayoutProps | ColorProps | BackgroundProps | BorderProps | TypographyProps;

const StyledVStack = styled(VStack)<FlexBoxType & OutlineProps>(
  typography,
  (props) => ({
    outline: props.outline,
  }),
  {
    textOverflow: 'clip',
  }
);
